/**
 * Tiny helper for in-scene CTA buttons that should advance the demo to
 * the next screen when clicked. Issues a fire-and-forget POST to
 * /api/control/next; in manual mode the backend releases the next
 * batch of events. In auto mode the call is a no-op (the run loop
 * doesn't block).
 *
 * Used by the click-driven CTAs scattered across the trade arcs
 * (T1 0.5 Submit a proposal, T1 1.1/1.2/1.3 Continue, T1 1.5 Create
 * Proposal, T2 4.1 Submit, T2 4.2 Submit reorder, etc.) — see the
 * "Cat-2 buttons" amendment batch for the full list.
 *
 * Same shape as PresenterChrome's `post("/control/next")` but living
 * outside the chrome component so scene components can call it
 * without prop-drilling a callback from the page level.
 */
export function advanceScreen(): void {
  // catch() swallows network errors so a transient blip doesn't
  // bubble an unhandled promise rejection through React's tree.
  fetch("/api/control/next", { method: "POST" }).catch(() => undefined);
}
